export default {
  columns: {
    offerName: 'Offer name',
    type: 'Type',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    details: 'Details',
    schedule: 'Schedule',
    startDate: 'Start date',
    images: 'Image',
  },
  actions: {
    edit: 'Edit',
    rename: 'Rename',
    delete: 'Delete',
    set_active: 'Set active',
    set_inactive: 'Set inactive',
    cancel: 'Cancel',
    confirm: 'Confirm',
    activate: 'Replace & Activate',
    manage_images: 'Edit Image',
  },
  toasts: {
    offer_enabled: '{{offer}} is now the active offer for {{for}}',
    offer_disabled: '{{offer}} set to Inactive.',
    update_failed: 'The offer update failed.',
    successfully_deleted: 'The offer has been deleted successfully',
    delete_failed: 'The offer deletion failed',
  },
  title: 'Manage All Offers',
  popups: {
    delete: {
      title: 'Are you sure you want to delete this offer?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Replacing master offers is not allowed',
      title: 'Replace active offer for this time period?',
      description:
        'You’re activating {{offer}} on {{weekday}}{{between}}. This will deactivate the current active offer {{currentOffer}} for the same time period.',
      between: ', between {{start}}-{{end}}',
    },
  },
};
